<template>
  <div>
  <initio-panel @submit-handler="submitHandler" :errors="errors" :hide-submit="true">
    <template v-slot:title>
      My car quote
    </template>
    <template v-slot:sidebar>

       <initio-quote-overview location="top" v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')"  v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly">
        </initio-quote-overview>
      <br />
      <initio-quote-overview class="is-hidden-mobile" v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')"  location="bottom" v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly">
        </initio-quote-overview>
    </template>
    <template v-slot:form_footer>
      <hr />

      <div class="notification is-info-blue" v-if="quoteDiscountResellerName">
        <strong>Discount applied.</strong> Your {{ quoteDiscountResellerName }} discount has been applied.
      </div>

      <div class="columns" v-if="!isLoggedIn">
        <div class="column has-text-centered">
          <strong>Already have insurance with us?</strong> <a href="/app/login?redirect=/spa/vehicle/new">Login</a>
        </div>
      </div>

      <div class="columns">
        
        <div class="column">
          <div class="box quote-box" :class="{'is-loading': quoteIsLoading}" data-item="monthly" >
            <SpinnerSvg class="loading-spinner" />

            <div class="quote-box__monthly-benefit has-text-centered">
              <div class="is-uppercase">Monthly
                <a href="#" @click.prevent="toggleModal('How monthly works')" class="how-monthly-works-icon-link">i</a>
              </div>
            </div>

            <div class="columns is-centered is-multiline">
              <div class="column is-10 mt-4 has-text-centered" v-if="!quoteErrors">
                  <h5 class="has-text-primary title is-size-7 mb-2 has-text-weight-black" v-if="quotePremiumMonthlyDiscountAmount">Discount of {{quotePremiumMonthlyDiscountAmount | toCurrency}}</h5>
                  <h3 class="title mb-2 has-text-weight-black"><sup class="is-size-6">$</sup> <span v-if="quotePremiumMonthly">{{quotePremiumMonthly | toCurrencyNoSymbol}}</span></h3>
                  <!--<p class=" has-text-grey is-size-7 mb-1" v-if="quotePremiumAnnual">({{quotePremiumAnnual | toCurrency}} Annually)</p>-->
                  <p class="has-text-grey is-size-7 mb-5">Monthly payment, NZD, inc GST.</p>
                  <button class="button is-cta is-large is-fullwidth has-text-weight-bold" @click="setPaymentInterval('monthly')"><span class="is-size-5-mobile is-size-5-widescreen is-size-6-tablet">Get Monthly Insurance</span></button>
                  <p class="has-text-grey is-size-7 mt-2">Credit card payment only</p>
              </div>
              <div class="column is-10 has-text-centered" v-if="quoteErrors">
                <div class="notification is-danger">
                  There was a problem loading the quote, please try again
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="box quote-box" :class="{'is-loading': quoteIsLoading}" data-item="yearly" >
            <SpinnerSvg class="loading-spinner" />
            <div class="quote-box__monthly-benefit has-text-centered">
              <div class="is-uppercase">Yearly
                <a href="#" @click.prevent="toggleModal('How yearly works')" class="how-monthly-works-icon-link">i</a>
              </div>
            </div>
            <div class="columns is-centered is-multiline">
              <div class="column is-10 mt-4 has-text-centered" v-if="!quoteErrors">
                  <h5 class="has-text-primary title is-size-7 mb-2 has-text-weight-black" v-if="quotePremiumYearlyDiscountAmount">Discount of {{quotePremiumYearlyDiscountAmount | toCurrency}}</h5>
                  <h3 class="title mb-2 has-text-weight-black"><sup class="is-size-6">$</sup> <span v-if="quotePremiumYearly">{{ quotePremiumYearly | toCurrencyNoSymbol}}</span></h3>
                  <p class="has-text-grey is-size-7 mb-5">Payment for year, NZD, inc GST.</p>
                  <button class="button is-cta is-large is-fullwidth has-text-weight-bold" @click="setPaymentInterval('yearly')"><span class="is-size-5-mobile is-size-5-widescreen is-size-6-tablet">Get Yearly Insurance</span></button>
                  <p class="has-text-grey is-size-7 mt-2">Credit card, Online EFTPOS or Account2Account</p>
              </div>
              <div class="column is-10 has-text-centered" v-if="quoteErrors">
                <div class="notification is-danger">
                  There was a problem loading the quote, please try again
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <a href="#email_quote_modal" class="box-quote__email-quote-panel__link" @click.prevent="toggleModal('Email Quote')">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.80002 6.2998C3.4805 6.2998 2.40002 7.38028 2.40002 8.6998V21.2998C2.40002 22.6193 3.4805 23.6998 4.80002 23.6998H25.2C26.5195 23.6998 27.6 22.6193 27.6 21.2998V8.6998C27.6 7.38028 26.5195 6.2998 25.2 6.2998H4.80002ZM4.80002 7.4998H25.2C25.3758 7.4998 25.5387 7.53848 25.6875 7.60293L15.8532 16.4436C15.3071 16.9346 14.6731 16.9346 14.1282 16.4436L4.31252 7.60293C4.46135 7.53848 4.62425 7.4998 4.80002 7.4998ZM3.60938 8.5873L13.3219 17.3341C14.2746 18.1919 15.7066 18.1908 16.6594 17.3341L26.3908 8.5873C26.3943 8.6248 26.4002 8.66113 26.4002 8.6998V21.2998C26.4002 21.9748 25.8752 22.4998 25.2002 22.4998H4.80016C4.12516 22.4998 3.60016 21.9748 3.60016 21.2998V8.6998C3.60016 8.66113 3.60602 8.6248 3.60953 8.5873H3.60938Z" fill="black"></path>
        </svg>  Email this quote
      </a>

      <payment-breakdown-graph :breakdownsByInterval="quoteBreakdownsByInterval" />
      <initio-quote-overview class="is-visible-mobile" location="bottom" v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly" />
    </template>
    <template v-slot:after_form>
      <div v-if="debugList.length" class="columns">
        <div class="column" v-for="(debug_by_payment_interval, index) in debugList" :key="index">
          <div class="quote_debug is-hidden-mobile">
            <div class="box">
              <h4 class="subtitle is-5">Debug {{ debug_by_payment_interval.type }}</h4>
              <div class="content">
                <ol>
                  <li v-for="(item, index)  in debug_by_payment_interval.quote_debug" :key="index">
                    <div v-html="item"></div>
                  </li>
                </ol>
                <hr />
                <code>
                  Input vars
                  <ol>
                    <li v-for="(item, index)  in debug_by_payment_interval.quote_input_debug" :key="index">
                      {{ index }}: <span v-html="item"></span>
                    </li>
                  </ol>
                </code>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </initio-panel>

  <modal
      v-if="modalOpen"
      :class="{ 'is-active': modalOpen }"
      v-on:childToParent="toggleModal"
      :title="modalTitle"
  >


    <div v-if="modalTitle === 'How monthly works'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
        <tbody><tr><td>Month to month insurance policy (just like a subscription)</td></tr>
        <tr><td>We automatically renew your policy each month (always insured)</td></tr>
        <tr><td>Your selected credit card is charged with the monthly premium</td></tr>
        <tr><td>We always tell you when we have renewed and charged your card</td></tr>
        <tr><td>You can cancel or change your monthly insurance anytime</td></tr>
        <tr><td>We always tell you what next month's insurance cost will be</td></tr>
        <tr><td>We let you know if your card declines or expires</td></tr>
        </tbody>
      </table>
      <strong>Why does Monthly cost more?</strong>
      <p>With a monthly payment we don't receive all of the money upfront.  This affects how the insurer funds customer claim payments. In addition, there is more cost associated with payment processing as there are a greater number of transactions. </p>
      <p><a class="" href="/how-monthly-insurance-works" target="_blank">Learn more</a></p>
    </div>

    <div v-if="modalTitle === 'How yearly works'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0"  class="table">
        <p>A traditional annual insurance policy:</p>
        <tr><td>Purchase cover for a year in advance (credit card, or 'account 2 account' transfer)</td></tr>
        <tr><td>You can cancel or change your annual insurance anytime</td></tr>
        <tr><td>Next year, we will remind you a month ahead of when the policy is due to renew</td></tr>
        <tr><td>Logging into your initio dashboard will enable you to see the renewal premium</td></tr>
        <tr><td>You can renew the cover directly from within your initio dashboard</td></tr>
        <tr><td>Its an annual contract and the payment will change each year</td></tr>
      </table>
    </div>

    <form @submit.prevent="submitEmailQuoteHandler" v-if="modalTitle === 'Email Quote'">

      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input
              required="required"
              class="input"
              type="text"
              name="name"
              v-model="emailQuoteFormData.name"
              placeholder="e.g Alex Smith" />
        </div>
      </div>

      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input
              required="required"
              class="input"
              name="email"
              type="email"
              v-model="emailQuoteFormData.email"
              placeholder="e.g. alexsmith@gmail.com" />
        </div>
      </div>

      <div class="field">
        <label class="label">Personal reference</label>
        <div class="control">
          <input
              class="input"
              name="reference"
              type="text"
              placeholder="e.g. quote-2"
              data-addressautocomplete
              autocomplete="off"
              v-model="emailQuoteFormData.ref"
          />
        </div>
        <p class="help">Optional - to help identify the email</p>
      </div>

      <div v-if="emailQuoteSent">
        <div class="notification is-primary">
          Your quote has been successfully sent
        </div>
        <button class="button close-modal" @click.prevent="resetEmailQuote(); toggleModal();">Close</button>
      </div>

      <div class="notification is-warning" v-if="emailQuoteErrors.length">
        {{emailQuoteErrors[0]}}
      </div>

      <div class="buttons" v-if="!emailQuoteSent">
        <button class="button is-primary submit-btn" :class="{ 'is-loading': emailQuoteIsLoading }">Send quote</button>
        <button class="button close-modal" @click.prevent="toggleModal()">Cancel</button>
      </div>

    </form>
  </modal>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioQuoteOverview from '@/components/partials/QuoteOverview.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import SpinnerSvg from '@/components/partials/SpinnerSvg.vue'
import PaymentBreakdownGraph from '@/components/partials/PaymentBreakdownGraph.vue'

import debounce from "lodash.debounce";
import { mapGetters } from 'vuex'
const axios = require("axios");
import cloneDeep from "lodash.clonedeep";

// import VueRouter from 'vue-router'
import { api } from '@/store/store.js';

export default {
  components: {
    InitioPanel,
    InitioQuoteOverview,
    SpinnerSvg,
    PaymentBreakdownGraph
  },
  mixins: [
    stepSubmit
  ],
  methods: {
    submitHandler() {
      let context = this;

      this.$store.commit('updateBackendData', {
          'Vehicle.Quote': {
            vehicle_quote_premium_raw: (this.paymentInterval == 'monthly') ? this.quotePremiumMonthly : this.quotePremiumYearly,
            vehicle_quote_discount_raw: (this.paymentInterval == 'monthly') ? this.quotePremiumMonthlyDiscountAmount : this.quotePremiumYearlyDiscountAmount,
            payment_interval: this.paymentInterval,
          }
        }
      );

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
          
        }, error => {
          console.error("VehicleQuote Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    },
    resetEmailQuote() {
      this.emailQuoteSent = null;
      this.emailQuoteErrors = [];
      this.emailQuoteIsLoading = false;
      this.emailQuoteFormData.ref = "";
    },
    submitEmailQuoteHandler(){
      this.emailQuoteErrors = [];
      this.emailQuoteIsLoading = true;
      this.emailQuoteSent = null;

      axios.post(`${api.url + api.version}vehicle/new/email-vehicle-quote/${this.sessionId()}`, this.emailQuoteFormData)
          .then(response => {
            this.emailQuoteIsLoading = false;
            if( response.data.results && response.data.results.success ){
              const results = response.data.results;
              this.emailQuoteSent = true;
            } else {
              // console.log(response.data);
              if( response.data.results.errors ){
                this.emailQuoteErrors = [response.data.results.errors];
              } else {
                this.emailQuoteErrors = ["There was a problem trying to send this email, please reload and try again."];
              }

            }
          }, error => {
            this.emailQuoteIsLoading = false;
            console.error(error, "Email send error");
            this.emailQuoteErrors = ["There was a problem trying to send this email, please reload and try again."];
          });
    },
    resetDebug() {
      this.debugList =  [];
    },
    getQuote:   debounce(function(updatedAnswers) {
      this.quoteIsLoading = true;
      this.quoteErrors = false;
      // console.log(this.sessionId());

      // There is a bit of a delay while the slider component gets ready and returns a value.
      // Just keep the loading icon until we get a vehicle_cover_type
      const cover_type = updatedAnswers['Vehicle.Quote']['vehicle_cover_type'];
      if( ! cover_type ){
        return false;
      }

      // Also keep loading/waiting unless we have a sum_insured that isn't 0 when non TPO
      if( cover_type !== 'third-party-only' && ! updatedAnswers['Vehicle.Quote']['vehicle_sum_insured_amount'] ){
        return false;
      }

      // Also keep loading/waiting if full cover and the vehicle_low_usage question is not answered
      if( cover_type === 'full' ){
        if( !updatedAnswers['Vehicle.Quote']['vehicle_low_usage'] ){
          return false;
        }
      }

      // when clicking fast, sometimes third-party-only or third-party-fire-theft quote gets triggered with old form data (race condition with formulate?), ignore if this is the case
      if( ( cover_type == 'third-party-only' || cover_type == 'third-party-fire-theft' ) && ! updatedAnswers['Vehicle.Quote']['vehicle_excess_third_party'] ){
        return false;
      }

     // Handle preventing submitting data when the chosen sum-insured is out-side the valid plate range ( which then fires a out-of-bounds email on backend)
     // This is specifically if they go back and change a plate to a sum_insured outside the price bounds of the first plate
     // There should be a second update where vue formulate kicks in with the updated sum_insured from the slider
     if( cover_type === 'full' || cover_type === 'third-party-fire-theft'  ) {

       const sum_insured = parseInt(updatedAnswers['Vehicle.Quote']['vehicle_sum_insured_amount']);
       const max_low = parseInt(this.answers['Vehicle.Plate'].vehicle_price_low);
       const max_high = parseInt(this.answers['Vehicle.Plate'].vehicle_price_high);

       if (sum_insured < max_low || sum_insured > max_high) {
         //   console.log('sum_insured', sum_insured, 'max_low', max_low, 'max_high', max_high )
         // console.log('cancelled quote request since invalid sum_insured within params');
         return false;
       }
     }

      // All the data should now be ready to provide to the quote API ( and prevent mismatch backend errors on the quote handler )

      // Cancel any existing out-going requests ( so they don't pile up, or change the price on different request params )
      this.axiosCancelTokenSource.cancel();

      // Request a quote
      axios.post(`${api.url + api.version}vehicle/new/premium/${this.sessionId()}`, { cancelToken: this.axiosCancelTokenSource.token, ...updatedAnswers['Vehicle.Quote']})
          .then(response => {
            this.quoteIsLoading = false;
            this.quoteBreakdownsByInterval = {};
            if( response.data.results && response.data.results.yearly && response.data.results.monthly ){
              const results = response.data.results;

              this.quotePremiumMonthly = results.monthly.total_cost_inc_gst;
              this.quotePremiumYearly = results.yearly.total_cost_inc_gst;
              this.quotePremiumYearlyDiscountAmount = results.yearly.discount_value_inc_gst ?  results.yearly.discount_value_inc_gst : false;
              this.quotePremiumMonthlyDiscountAmount = results.monthly.discount_value_inc_gst ?  results.monthly.discount_value_inc_gst : false;
              this.quoteDiscountResellerName = results.discount_reseller_name ? results.discount_reseller_name : '';
              this.quoteErrors = false;

              this.quoteBreakdownsByInterval = {
                monthly: response.data.results.monthly.payment_breakdown,
                yearly: response.data.results.yearly.payment_breakdown,
              }

              if( results.monthly.quote_debug && results.yearly.quote_debug  ){
                this.debugList = [
                    {
                      type: 'Monthly',
                      quote_debug: results.monthly.quote_debug ,
                      quote_input_debug: results.monthly.quote_input_debug
                    },
                    {
                      type: 'Yearly',
                      quote_debug: results.yearly.quote_debug ,
                      quote_input_debug: results.yearly.quote_input_debug
                    },
                ];
              }

            } else {
              // console.log(response.data);
              this.quoteErrors = true;
            }
          }, error => {
            console.error(error, "Get quote error");
            this.quoteErrors = true;
          });

    }, 200), // Add delay before requesting quote, needs about 180 for the vue elements to property show/hide/update
    toggleModal: function (title='') {
      this.modalTitle = title;
      this.modalOpen = ! this.modalOpen;
    },

    setPaymentInterval(interval) {
      this.paymentInterval = interval;

      this.$store.commit('updateBackendData', {
          'Vehicle.Quote': {
            payment_interval: this.paymentInterval,
          }
        }
      );
    }
  },
  watch: {
    // Update the store with the local component state on change with debounce
    answers (updatedAnswers) {
      // debounce here ?
      this.getQuote(updatedAnswers);
    },
  },
  mounted () {

    this.$store.dispatch('getSchema', 'new/vehicle-quote' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })

    this.getQuote(this.answers);
  },
  data () {
    return {
      modalOpen: false,
      modalTitle: '',
      emailQuoteIsLoading: false,
      emailQuoteErrors: [],
      emailQuoteSent: false,
      emailQuoteFormData: {
        name: '',
        email: '',
        ref: ''
      },
      errors: [],
      schema: [],
      quoteIsLoading: true,
      quoteErrors: false,
      paymentInterval: '',
      quotePremiumMonthly: null,
      quotePremiumYearly: null,
      quotePremiumMonthlyDiscountAmount: null,
      quotePremiumYearlyDiscountAmount: null,
      quoteDiscountResellerName: null,
      quoteBreakdownsByInterval: {},
      debugList: [],
      axiosCancelTokenSource:  axios.CancelToken.source(),
    }
  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      sessionId: 'getSessionId',
      isLoggedIn: 'isLoggedIn',
    })
  },
}

</script>

<style scoped lang="scss">

  .quote-box {
    position: relative;
    padding-top: 0;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 0;

    header {
      background: $initio-green;
      color: white;
      padding: 10px;
      border-bottom: 1px solid $light-grey;
      font-size: 10px;
      //border-top-left-radius: 5px;
      //border-top-right-radius: 5px;
    }

    &:after {
      transition: 200ms ease-in-out;
      content: '';
      display: block;
      position: absolute;
      left:0;
      right:0;
      top:0;
      bottom:0;
      background: white;
      opacity: 0;
      pointer-events: none;
    }

    .title {
      font-size:2.25rem;
    }

    .is-cta {
      filter: drop-shadow(0px 2px 11px rgba(39, 39, 39, 0.243772));
    }
  }
  .quote-box.is-loading {
    &:after {
      opacity: 0.4;
      pointer-events: auto;
    }
    .loading-spinner {
      opacity: 1;
    }
  }

  .loading-spinner {
    position: absolute;
    top: 80px;
    right: 50%;
    margin-right: -20px;
    z-index: 15;
    transition: 200ms ease-in-out;
    opacity: 0;
  }

  header,
  .quote-box__email-quote-panel,
  .quote-box__monthly-benefit {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .quote-box__monthly-benefit {
    font-weight: 900;
    font-size: 12px;
  }

  .quote-box__email-quote-panel {
    border-top: 1px solid $light-grey;
  }

  .how-monthly-works-icon-link {
    background: $light-grey;
    height: 20px;
    width: 20px;
    color: white;
    text-transform: none;
    font-weight: normal;
    margin-left: 5px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    line-height: 20px;
    &:hover {
      background: #00A7FF;
      color: white;
    }
  }

  .quote-box__monthly-benefit {
    border-bottom: 1px solid $light-grey;
    padding: 8px;
  }

  .box-quote__email-quote-panel__link {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    text-align: center;
    &:hover {
      background: #f9f9f9;
    }
    svg {
      margin-right: 5px;
    }
  }

  .quote_debug {
    margin-top: 20px;
    position:relative;
    z-index:30;

    > .box {
      background:rgba(255,255,255,0.5);
    }

    ol li {
      margin-bottom: 15px;
      font-size: 14px;
    }
  }
</style>
<style lang="scss">

.is-visible-mobile {
  display:none;

  @include mobile() {
    display: block;
  }

}
</style>